import axios from 'axios'

import { fetchApi } from './'

export const googleForwardGeocoding = (query='') => async (dispatch, getState) => {
    let res = await dispatch(fetchApi(`geocode/?query=${query}`))
    return res
}